import { render, staticRenderFns } from "./post-list.vue?vue&type=template&id=3fd79c6a&scoped=true&"
import script from "./post-list.vue?vue&type=script&lang=js&"
export * from "./post-list.vue?vue&type=script&lang=js&"
import style0 from "./post-list.vue?vue&type=style&index=0&id=3fd79c6a&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd79c6a",
  null
  
)

export default component.exports